var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoritoSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34142_1329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0L6 46.5C5.99981 46.7605 6.06745 47.0165 6.19627 47.2429C6.32509 47.4693 6.51065 47.6583 6.73468 47.7912C6.9587 47.9241 7.21347 47.9963 7.47391 48.0009C7.73436 48.0054 7.99149 47.942 8.22 47.817L24 39.207L39.78 47.817C40.0085 47.942 40.2656 48.0054 40.5261 48.0009C40.7865 47.9963 41.0413 47.9241 41.2653 47.7912C41.4894 47.6583 41.6749 47.4693 41.8037 47.2429C41.9325 47.0165 42.0002 46.7605 42 46.5V0H6Z",
    fill: "#111117"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_34142_1329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4179 31.1645C16.8389 31.4615 16.1819 30.941 16.2989 30.2765L17.5439 23.1815L12.2594 18.1475C11.7659 17.6765 12.0224 16.8155 12.6839 16.7225L20.0309 15.6785L23.3069 9.18799C23.6024 8.60299 24.4019 8.60299 24.6974 9.18799L27.9734 15.6785L35.3204 16.7225C35.9819 16.8155 36.2384 17.6765 35.7434 18.1475L30.4604 23.1815L31.7054 30.2765C31.8224 30.941 31.1654 31.4615 30.5864 31.1645L23.9999 27.7805L17.4179 31.1645Z",
    fill: "#C51D1D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34142_1329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_34142_1329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritoSelected);
export default __webpack_public_path__ + "static/media/favorito-selected.9f10510128b600045289395b5b86a57c.svg";
export { ForwardRef as ReactComponent };